export default "__VITE_ASSET__fba144d4__"